export default __webpack_public_path__ + "static/media/opologic_mono_logo.14fdc07d.svg";